import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleNotch, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { IAttachmentsStore } from '../attachments.store';
import { IAttachmentUploadService } from '../attachmentUploadService';

library.add(faCircleNotch, faDownload);

export const AttachmentDownloadContainer = observer((): ReactElement => {
  const uploadService = useInjection(IAttachmentUploadService.$);
  const attachmentStore = useInjection(IAttachmentsStore.$);
  const { t } = useTranslator();
  const { attachmentId } = useParams<{ attachmentId: string }>();

  const onDownload = async (): Promise<void> => {
    const store = attachmentStore;
    await uploadService.downloadAttachmentsAsync(store.selectedAttachments.isAllSelected, store.selectedAttachments.ids, attachmentId);
  };

  const isDisabled =
    (!attachmentStore.selectedAttachments.isAllSelected && attachmentStore.selectedAttachments.ids && !attachmentStore.selectedAttachments.ids.length) ||
    uploadService.data.currentDownloadAttachment.some((a) => a.isBatch) ||
    !attachmentStore.attachments.length;

  const isBatch = uploadService.data.currentDownloadAttachment.some((a) => a.isBatch);

  return (
    <Button
      variant='outlined'
      onClick={() => {
        void onDownload();
      }}
      disabled={isDisabled}
      startDecorator={<FontAwesomeIcon icon={faDownload} />}
      endDecorator={
        isBatch ? (
          <FontAwesomeIcon
            icon={faCircleNotch}
            className='fa-spin'
          />
        ) : null
      }
    >
      {t('download_attachments')}
    </Button>
  );
});
